module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "auth-page auth-register-page"
  }, [_c('form', {
    staticClass: "auth-form register-form",
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit()
      }
    }
  }, [_c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "autocomplete": "off",
      "name": "hidden",
      "type": "text"
    }
  }), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-item": "",
      "px-0": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-center": ""
    }
  }, [_c('div', {
    staticClass: "avatar-area"
  }, [_c('span', {
    staticClass: "avatar-img"
  }, [_c('img', {
    ref: "avatar",
    staticClass: "avatar",
    attrs: {
      "src": "/static/images/user-new.svg",
      "id": "avatar"
    }
  })]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "avatar-upload"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    ref: "avatar_file",
    staticClass: "avatar-file",
    attrs: {
      "type": "file",
      "name": "avatar_file",
      "id": "avatar_file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.imageChanged($event)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "avatar_file"
    }
  }, [_vm._v("Choose image")])])])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-center": "",
      "relative": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.username),
      expression: "user.username"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        min: 3,
        max: 20,
        regex: /^[A-Za-z0-9_.]+$/,
      }),
      expression: "{\n              required: true,\n              min: 3,\n              max: 20,\n              regex: /^[A-Za-z0-9_.]+$/,\n            }"
    }],
    staticClass: "username",
    attrs: {
      "type": "text",
      "name": "username",
      "placeholder": "@username"
    },
    domProps: {
      "value": (_vm.user.username)
    },
    on: {
      "blur": _vm.onBlur,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "username", $event.target.value)
      }
    }
  }), _vm._v(" "), (!_vm.is_username_available) ? _c('label', {
    staticClass: "error--text"
  }, [_vm._v("already taken")]) : _vm._e()]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-center": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.display_name),
      expression: "user.display_name"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:20'),
      expression: "'required|max:20'"
    }],
    staticClass: "displayname",
    attrs: {
      "type": "text",
      "name": "name",
      "autocomplete": "off",
      "placeholder": "Name"
    },
    domProps: {
      "value": (_vm.user.display_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "display_name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-center": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.city),
      expression: "user.city"
    }],
    attrs: {
      "type": "text",
      "name": "city",
      "placeholder": "City"
    },
    domProps: {
      "value": (_vm.user.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "city", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-center": ""
    }
  }, [_c('country-select', {
    staticClass: "country",
    attrs: {
      "name": "country",
      "country": _vm.country,
      "topCountry": "US"
    },
    model: {
      value: (_vm.user.country),
      callback: function($$v) {
        _vm.$set(_vm.user, "country", $$v)
      },
      expression: "user.country"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-center": ""
    }
  }, [_c('v-select', {
    staticClass: "country",
    attrs: {
      "items": _vm.age_group,
      "label": "Age Group",
      "persistent-hint": "",
      "return-object": "",
      "single-line": "",
      "name": "social_provider"
    },
    model: {
      value: (_vm.user.age_group),
      callback: function($$v) {
        _vm.$set(_vm.user, "age_group", $$v)
      },
      expression: "user.age_group"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-center": ""
    }
  }, [_c('v-select', {
    staticClass: "country",
    attrs: {
      "items": _vm.social_platform,
      "label": "Social Platform",
      "persistent-hint": "",
      "return-object": "",
      "single-line": "",
      "name": "social_provider"
    },
    model: {
      value: (_vm.user.social_provider),
      callback: function($$v) {
        _vm.$set(_vm.user, "social_provider", $$v)
      },
      expression: "user.social_provider"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-center": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.social_user_name),
      expression: "user.social_user_name"
    }],
    staticClass: "displayname",
    attrs: {
      "type": "text",
      "name": "social_user_name",
      "autocomplete": "off",
      "placeholder": "Social Platform Username"
    },
    domProps: {
      "value": (_vm.user.social_user_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "social_user_name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-center": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    staticClass: "email",
    attrs: {
      "type": "email",
      "name": "email",
      "autocomplete": "new-password",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-center": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:5|max:16'),
      expression: "'required|min:5|max:16'"
    }],
    staticClass: "password",
    attrs: {
      "type": "password",
      "name": "password",
      "autocomplete": "new-password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.user.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "password", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-center": ""
    }
  }, [_c('div', {
    staticClass: "dflex justify-space-between align-center mt-2"
  }, [_c('p', {
    staticClass: "regular-checkbox ma-0"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.terms),
      expression: "terms"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "id": "terms",
      "type": "checkbox",
      "name": "terms"
    },
    domProps: {
      "checked": Array.isArray(_vm.terms) ? _vm._i(_vm.terms, null) > -1 : (_vm.terms)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.terms,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.terms = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.terms = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.terms = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "terms"
    }
  }, [_c('span', {
    staticClass: "terms-text"
  }, [_vm._v("Accept Terms")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "terms-text",
    attrs: {
      "to": "/terms"
    }
  }, [_vm._v("\n              Terms & Conditions\n            ")])], 1)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-center": "",
      "mt-3": ""
    }
  }, [_c('v-btn', {
    staticClass: "create-account-button",
    attrs: {
      "block": "",
      "round": "",
      "dark": "",
      "type": "submit"
    }
  }, [_vm._v("\n            Create account\n          ")])], 1)], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-70f07bec","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/auth/register_by_listener.vue
// module id = 1770
// module chunks = 180